<template>
  <div id="wrapper">
    <div class="content">
      <div class="hpanel">
        <div class="panel-body" v-if="pdf">
          <div class="embed-container">
            <embed :src="pdf"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.embed-container {
  overflow: hidden;
  padding-top: 56.25%; /* 16:9*/
  position: relative;
}

.embed-container embed {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
<script>

export default {
  name: 'TimestampedFileCertification',
  data () {
    return {
      pdf: null,
      timestampedFileId: null
    }
  },
  methods: {
    getResources: function () {
      if (this.timestampedFileId !== null && typeof this.timestampedFileId !== 'undefined') {
        this.axios.get('/timestamped/' + this.timestampedFileId + '/certificate', {responseType: 'blob'})
          .then((response) => {
            let pdfBlob = new Blob([response.data], {type: 'application/pdf'})
            this.pdf = URL.createObjectURL(pdfBlob)
          }).catch((error) => {
            if (error.response.status === 403) {
              this.$router.replace({name: 'Error403', params: {'0': ''}})
            } else if (error.response.status === 404) {
              this.$router.replace({name: 'Error404', params: {'0': ''}})
            } else {
              this.$notify({
                type: 'danger',
                title: 'An error has occurred',
                content: 'We are sorry but we encountered an error, please refresh your page or contact support!',
                placement: 'bottom-right'
              })
            }
          })
      }
    }
  },
  beforeMount () {
    this.timestampedFileId = parseInt(this.$route.params.poe_id)
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/timestampFiles/TimestampedFileCertification.vue